@if(info(); as transferInfo) {
<div class="tw-min-w-0 tw-flex tw-flex-col tw-gap-1">
  @if(compact()) {
  <div class="tw-flex tw-flex-wrap tw-items-start tw-gap-2">
    <span class="surface-info tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full" aria-hidden="true">
      <mat-icon>person</mat-icon>
    </span>
    <div class="tw-min-w-0 tw-flex-1">
      <div class="tg-sm tw-font-semibold tw-break-words">{{ primaryLine() }}</div>
      @if(transferInfo.statusLabel) {
      <span class="uw-tag uw-tag-secondary">{{ transferInfo.statusLabel }}</span>
      }
    </div>
    @if(showHandoffDetails()) {
    <span class="uw-tag tw-shrink-0" [ngClass]="'uw-tag-' + classificationTone()"
      [attr.aria-label]="transferInfo.handoff?.classification ? 'Classification: ' + classificationLabel() : classificationLabel()"
      [matTooltip]="transferInfo.handoff?.classification ? 'Classification: ' + classificationLabel() : classificationLabel()"><span class="tw-font-semibold">{{ classificationLabel() }}</span></span>
    }
  </div>
  } @else {
  <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
    <div class="tg-sm tw-font-semibold tw-truncate">{{ primaryLine() }}</div>
    @if(transferInfo.statusLabel) {
    <span class="uw-tag uw-tag-secondary tw-shrink-0">{{ transferInfo.statusLabel }}</span>
    }
  </div>

  }

  @if(secondaryLine() || transferInfo.leadState) {
  <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
    @if(secondaryLine(); as phone) {
    <span class="tg-sm text-muted tw-truncate">{{ phone }}</span>
    }
    @if(transferInfo.leadState) {
    <span class="uw-tag uw-tag-secondary tw-shrink-0">{{ transferInfo.leadState }}</span>
    }
  </div>
  }

  @if(transferInfo.campaignName) {
  <div class="tg-sm text-muted tw-truncate">{{ transferInfo.campaignName }}</div>
  }

  @if(transferInfo.summary) {
  <div class="tg-sm text-muted" [class.tw-line-clamp-2]="compact()" [class.tw-line-clamp-3]="!compact()" [title]="transferInfo.summary">{{ transferInfo.summary }}</div>
  }
  @if(showHandoffDetails()) {
  @if(!compact()) {
  <div class="tg-sm tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
    @if(transferInfo.handoff?.classification) { <span>Classification:</span> }
    <span class="uw-tag" [ngClass]="'uw-tag-' + classificationTone()">{{ classificationLabel() }}</span>
  </div>
  }
  @if(transferInfo.handoff?.transcript?.trim(); as conversation) {
  @if(!compact()) {
  <div class="tg-sm tw-font-semibold">Conversation before transfer</div>
  }
  <div [ngClass]="compact() ? 'surface-main-darker tw-border tw-border-solid border-primary tw-rounded tw-px-2 tw-py-1' : ''">
  <div #transcript class="tw-overflow-y-auto tw-whitespace-pre-wrap tw-break-words"
    [ngClass]="compact() ? 'tw-text-sm tw-leading-5 tw-max-h-[3.75rem]' : 'tg-sm tw-max-h-40'"
    tabindex="0" role="region" aria-label="Conversation before transfer"
    (click)="$event.stopPropagation()" (keydown)="$event.key !== 'Escape' && $event.key !== 'Tab' && $event.stopPropagation()">{{ conversation }}</div>
  </div>
  } @else {
  <div class="tg-sm text-muted">No transcript available at handoff</div>
  }
  }
  @if(compact() && callStatus()) {
  <div class="tw-flex tw-justify-end">
    <span class="uw-tag uw-tag-info">{{ callStatus() }}</span>
  </div>
  }
</div>
}

@if(evidence(); as transferEvidence) {
<details class="uw-list-card tw-min-w-0 tg-sm" data-testid="transfer-evidence">
  <summary>Transfer evidence</summary>
  <div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
    <div>Reservation: {{transferEvidence.reservationUuid ? 'Reserved' : 'Not confirmed'}}</div>
    <div>Carrier result: {{carrierStatus() || (transferEvidence.dispatchedAt ? 'Submitted' : 'Not submitted or unknown')}}</div>
    <div>Human transfer: {{humanStatus() || 'No delivery result'}}</div>
    <p class="text-muted">A reservation or SIP response does not confirm a successful human transfer.</p>
    @for(field of evidenceFields(); track field.label){<div class="tw-break-all"><strong>{{field.label}}:</strong> {{field.value}}</div>}
  </div>
</details>
}
